import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST } from '../SQL';
import { function_COM_DocsCompra_Generar_JSON } from './DocsCompra/COM_DocsCompra_Cabecera';
import { function_COM_Pagos_Generar_JSON } from './Pagos/COM_Pagos_Cabecera';

export const function_COM_OperacionesDeCompra = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_COM_OperacionesDeCompra"

    try {
        const resulData = await llamadaAPI_GET("COM_OperacionesDeCompra/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_COM_DocsCompra_Pago_Insertar = async (DocCompraPago, BajaStockSinImportarDefinicionDeArticulo) => {
    const NombreFuncion = "function_COM_DocsCompra_Pago_Insertar";

    try {
        const docCompraResult = await llamadaAPI_POST("COM_DocsCompra_Pago/InsertarCompleto/" +
            BajaStockSinImportarDefinicionDeArticulo,
            DocCompraPago);
        return docCompraResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_COM_DocsCompra_Pago_Generar_JSON = async (IdDocCompra, IdTipoDocCompra, Fecha, IdCliente, NumeroFantasia,
    CodigoPuntoFiscal, Numero, CodigoMoneda, Cotizacion, ImporteBonificacionesDocCompra, ImporteRecargosDocCompra, 
    Concepto, Observaciones, IdDocCompraReferente, FEFecha, 
    CodigoCondicionVenta, FechaVencimiento, CodigoMonedaReferente, Terminal,
    Turno, IdProveedorDelivery, CodigoOperacionProveedorDelivery, CodigoResumenDePagoProveedorDelivery, 
    CodigoMesa, CantidadComensales, IdProfesionalMozo,
    FechaAperturaDocumentoAbierto, FechaCierreDocumentoAbierto, IdUsuarioCreador,
    ColeccionDetalles, ColeccionImpuestosDocCompra, ColeccionImputacionesContableDocCompra, ColeccionImputacionesCosteo, ColeccionProfesionalesACargo,
    IdPago, NumeroFantasiaPago,
    CodigoPuntoFiscalPago, NumeroPago, ImporteBonificacionesPago, ImporteRecargosPago, 
    ColeccionImputacionesFinanciera, ColeccionImpuestosPago, ColeccionImputacionesContablePago, 
    ColeccionRelacionesDocsCompraPagos, ColeccionImputacionesFinancieraRecargosBonificaciones) => {
    const NombreFuncion = "function_COM_DocsCompra_Pago_Generar_JSON";

    try {
        const DocCompra = await function_COM_DocsCompra_Generar_JSON(IdDocCompra, Turno, IdUsuarioCreador, 
            IdTipoDocCompra, IdCliente, Fecha, FEFecha, FechaVencimiento, 
            NumeroFantasia, CodigoPuntoFiscal, Numero, CodigoMoneda, Cotizacion, CodigoMonedaReferente, 
            ImporteBonificacionesDocCompra, ImporteRecargosDocCompra, Concepto, Observaciones, IdDocCompraReferente,
            CodigoCondicionVenta, IdProveedorDelivery, CodigoOperacionProveedorDelivery, CodigoResumenDePagoProveedorDelivery, 
            CodigoMesa, CantidadComensales, IdProfesionalMozo,
            FechaAperturaDocumentoAbierto, FechaCierreDocumentoAbierto, 
            ColeccionDetalles, ColeccionImpuestosDocCompra, ColeccionImputacionesContableDocCompra, ColeccionImputacionesCosteo, ColeccionProfesionalesACargo)

        const Pago = await function_COM_Pagos_Generar_JSON(IdPago, 
            Fecha, IdCliente, NumeroFantasiaPago, CodigoPuntoFiscalPago, NumeroPago, CodigoMoneda, Cotizacion,
            Observaciones, ImporteBonificacionesPago, 
            ImporteRecargosPago, ColeccionImputacionesFinanciera, ColeccionImpuestosPago, ColeccionImputacionesContablePago, 
            ColeccionRelacionesDocsCompraPagos, ColeccionImputacionesFinancieraRecargosBonificaciones)

        const JSON = {
            DocCompra: {}, Detalles: [],
            ImpuestosDocCompra: [], ImputacionesContableDocCompra: [], ImputacionesCosteo: [], ProfesionalesACargo: [],
            Pago: {}, ImputacionesFinanciera: [], ImpuestosPago: [], ImputacionesContablePago: [],
            RelacionesDocsCompraPagos: [], ImputacionesFinancieraRecargosBonificaciones: []
        };

        for (const key in DocCompra) {
            if (key === 'Impuestos') {
                JSON.ImpuestosDocCompra = DocCompra[key];
            } else if (key === 'ImputacionesContable') {
                JSON.ImputacionesContableDocCompra = DocCompra[key];
            } else if (Array.isArray(DocCompra[key])) {
                // Si es un array, mantenerlo al mismo nivel
                JSON[key] = DocCompra[key];
            } else {
                // Si no es un array, agregarlo dentro de DocCompra
                JSON.DocCompra[key] = DocCompra[key];
            }
        }
        
        for (const key in Pago) {
            if (key === 'Impuestos') {
                JSON.ImpuestosPago = Pago[key];
            } else if (key === 'ImputacionesContable') {
                JSON.ImputacionesContablePago = Pago[key];
            } else if (Array.isArray(Pago[key])) {
                // Si es un array, mantenerlo al mismo nivel
                JSON[key] = Pago[key];
            } else {
                // Si no es un array, agregarlo dentro de Pago
                JSON.Pago[key] = Pago[key];
            }
        }

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};